import { createSlice } from "@reduxjs/toolkit";
import { Createaccount } from "../../../pages/accounts/IAccount";
// this code for slice value for AddCard
export const AddCard = createSlice({
  name: "AddCard",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: {} as Createaccount,
  },
  reducers: {
    add_AddCard: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_add_AddCard: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
    },
    failure_api_call_add_AddCard: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    add_AddCard_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_AddCard_complete_api: (state, action) => {
      state.api_completed = false;
    },
  },
});
export default AddCard.reducer;
export const {
  add_AddCard,
  success_api_call_add_AddCard,
  failure_api_call_add_AddCard,
  create_AddCard_complete_api,
  add_AddCard_is_success,
} = AddCard.actions;
